<template>
  <Card.Base v-if="visible" class="mb-4">
    <Card.Title :icon="file ? 'Text' : undefined">
      <div v-if="file" class="font-primary -mt-0.5">Description</div>
      <Skeleton v-else class="w-[170px] h-4" />
    </Card.Title>
    <Card.Content>
      <template v-if="file">
        <div
          v-if="file.description"
          class="font-secondary [white-space:break-spaces]"
        >
          {{ file.description }}
        </div>
        <div v-else class="w-full flex justify-center py-3">
          <div
            v-if="isOwner"
            class="flex items-center text-green-700 font-primary font-medium cursor-pointer"
            @click="$emit('edit')"
          >
            <Icon :size="18" name="Pencil" class="stroke-green-700 mr-2" />
            Add description
          </div>
        </div>
      </template>
      <template v-else>
        <Skeleton class="w-10 h-2.5 mb-3" />
        <Skeleton class="w-[118px] h-3 mb-7" />
        <Skeleton class="w-10 h-2.5 mb-3" />
        <Skeleton class="w-[118px] h-3" />
      </template>
    </Card.Content>
  </Card.Base>
</template>

<script setup lang="ts">
import { Skeleton, Icon, Card } from '@dacr/ui'
import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'
import { computed } from 'vue'

const props = defineProps<{
  file?: CopyrightFile
  isOwner: boolean
  loading: boolean
}>()

defineEmits<{
  edit: []
}>()

const visible = computed(
  () => props.loading || props.isOwner || !!props.file?.description
)
</script>
